"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = exports.ToastStyled = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var framer_motion_1 = require("framer-motion");
var styles_1 = require("../../styles");
exports.ToastStyled = (0, styled_components_1.default)(framer_motion_1.motion.li)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  align-items: center;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  opacity: 1;\n  padding: 0 ", ";\n  user-select: none;\n  width: 100vw;\n\n  ", "\n\n  ", "\n\n  strong {\n    font-weight: bold;\n    opacity: 1;\n  }\n"], ["\n  ", "\n  align-items: center;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  opacity: 1;\n  padding: 0 ", ";\n  user-select: none;\n  width: 100vw;\n\n  ", "\n\n  ", "\n\n  strong {\n    font-weight: bold;\n    opacity: 1;\n  }\n"])), (0, styles_1.getP15)(), function (_a) {
    var theme = _a.theme, type = _a.type;
    return theme.colors["toast_".concat(type)];
}, function (_a) {
    var theme = _a.theme, type = _a.type;
    return type === 'error' ? 'white' : 'white';
}, (0, styles_1.getRelative)(100, 'mobile'), (0, styles_1.getRelative)(30, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", ";\n    padding: 0 ", ";\n  "], ["\n    height: ", ";\n    padding: 0 ", ";\n  "])), (0, styles_1.getRelative)(100, 'desktop'), (0, styles_1.getRelative)(30, 'desktop')), function (_a) {
    var isAbsolute = _a.isAbsolute;
    return isAbsolute ? 'position: absolute; top: 0; left: 0;' : '';
});
var Span = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n"], ["\n"])));
var variants = {
    initial: function (toastNumber) { return ({
        opacity: 0,
        scale: 1 - (toastNumber * 0.1),
        y: "".concat(100 * (toastNumber + 1), "%"),
        transition: __assign({}, (0, styles_1.getTransition)())
    }); },
    animate: function (toastNumber) { return ({
        opacity: 1 - (toastNumber * 0.1),
        scale: 1 - (toastNumber * 0.1),
        y: 0,
        transition: __assign({}, (0, styles_1.getTransition)())
    }); },
    exit: function (toastNumber) { return ({
        opacity: 0,
        scale: 1 - (toastNumber * 0.1),
        y: "".concat(100 * (toastNumber + 1), "%"),
        transition: __assign({}, (0, styles_1.getTransition)())
    }); }
};
var Toast = function (_a) {
    var children = _a.children, idx = _a.idx, type = _a.type;
    return ((0, jsx_runtime_1.jsx)(exports.ToastStyled, __assign({ type: type, index: idx, isAbsolute: idx !== 0, custom: idx, "aria-live": 'assertive', variants: variants, initial: 'initial', animate: 'animate', exit: 'exit' }, { children: (0, jsx_runtime_1.jsx)(Span, { dangerouslySetInnerHTML: { __html: children } }) })));
};
exports.Toast = Toast;
var templateObject_1, templateObject_2, templateObject_3;
